'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TableHeaderCell", {
    enumerable: true,
    get: function() {
        return TableHeaderCell;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTableHeaderCell = require("./useTableHeaderCell");
const _renderTableHeaderCell = require("./renderTableHeaderCell");
const _useTableHeaderCellStylesstyles = require("./useTableHeaderCellStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TableHeaderCell = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTableHeaderCell.useTableHeaderCell_unstable)(props, ref);
    (0, _useTableHeaderCellStylesstyles.useTableHeaderCellStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTableHeaderCellStyles_unstable')(state);
    return (0, _renderTableHeaderCell.renderTableHeaderCell_unstable)(state);
});
TableHeaderCell.displayName = 'TableHeaderCell';
